module.exports = __webpack_public_path__ + "static/media/me.cc1552d8.jpg";